import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

interface UnalignedEntry {
  paper_id: string;
  title: string;
  reason: string;
}

export function UnalignedPanel({ unaligned }: { unaligned: UnalignedEntry[] }) {
  const [open, setOpen] = useState(false);
  if (!unaligned.length) return null;
  // max-h is viewport-relative (40vh), not map-relative: this panel stacks
  // with OutOfScopePanel inside FieldDebateView's bottom-left wrapper, which
  // owns positioning and the container-relative height cap.
  return (
    <div className="w-[22rem] max-h-[40vh] flex flex-col bg-background/95 border border-border rounded-lg shadow-lg pointer-events-auto min-h-0">
      <div className="flex items-center px-3 py-2 shrink-0">
        <button
          type="button"
          onClick={() => setOpen((p) => !p)}
          className="flex items-center gap-1.5 text-muted-foreground text-xs font-semibold hover:text-foreground transition-colors"
        >
          {open ? (
            <ChevronDown className="w-3 h-3" />
          ) : (
            <ChevronRight className="w-3 h-3" />
          )}
          No clear stance ({unaligned.length})
        </button>
      </div>
      {open && (
        <div className="overflow-y-auto min-h-0">
          <div className="space-y-2 px-3 pb-3">
            {unaligned.map((u) => (
              <div key={u.paper_id} className="text-xs text-muted-foreground leading-snug">
                <div className="font-medium text-foreground">
                  {u.title || `Paper ${u.paper_id}`}
                </div>
                <div>{u.reason}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
